import { supabase } from "@/lib/supabase";

const DOCUMENTS_BUCKET = "documents";

/**
 * Public URL, signed URL vagy relatív path → storage object path.
 * A régi `…/object/public/documents/…` és az új relatív path is működik.
 */
export function storagePathFromFileUrl(fileUrlOrPath: string | null | undefined): string | null {
  if (!fileUrlOrPath) return null;
  const raw = fileUrlOrPath.trim();
  if (!raw) return null;

  const markers = [
    `/object/public/${DOCUMENTS_BUCKET}/`,
    `/object/sign/${DOCUMENTS_BUCKET}/`,
    `/object/authenticated/${DOCUMENTS_BUCKET}/`
  ];
  for (const marker of markers) {
    const idx = raw.indexOf(marker);
    if (idx >= 0) {
      const rest = raw.slice(idx + marker.length).split("?")[0] ?? "";
      return decodeURIComponent(rest);
    }
  }

  // Relatív path a bucketen belül (pl. quotes/2026-10-09/uuid.pdf)
  if (!/^https?:\/\//i.test(raw)) {
    return raw.replace(/^\//, "");
  }

  return null;
}

/** Signed URL előállítás; ha nem storage path, visszaadja az eredeti URL-t. */
export async function createSignedDocumentUrl(
  fileUrlOrPath: string | null | undefined,
  expiresInSeconds = 3600
): Promise<string | null> {
  if (!fileUrlOrPath) return null;
  const path = storagePathFromFileUrl(fileUrlOrPath);
  if (!path) return fileUrlOrPath;

  const { data, error } = await supabase.storage
    .from(DOCUMENTS_BUCKET)
    .createSignedUrl(path, expiresInSeconds);
  if (error || !data?.signedUrl) {
    throw new Error(error?.message ?? "Nem sikerült aláírt fájl-URL-t készíteni.");
  }
  return data.signedUrl;
}

/** Előnézethez: best-effort signed URL, hiba esetén null. */
export async function resolvePreviewUrl(
  fileUrlOrPath: string | null | undefined
): Promise<string | null> {
  try {
    return await createSignedDocumentUrl(fileUrlOrPath);
  } catch {
    return null;
  }
}
